@if (link) {
<a [routerLink]="link" [matTooltip]="tooltip">
  <person-icon
    [gender]="person.gender"
    [isChild]="type === 'Child'"
    [hasWarning]="isIncomplete"
    aria-hidden="true"
  ></person-icon>
  <span class="visually-hidden">{{ name }}</span>
</a>
} @if (!link) {
<span [matTooltip]="tooltip">
  <person-icon
    [gender]="person.gender"
    [isChild]="type === 'Child'"
    [hasWarning]="isIncomplete"
    aria-hidden="true"
  ></person-icon>
  <span class="visually-hidden">{{ name }}</span>
</span>
}
